import { iaRa } from 'lib/helpers/utility';

export const calculateTotals = (transactions) => {
  return iaRa(transactions).reduce(
    (acc, transaction) => {
      const {
        total_amount = 0,
        discount = 0,
        adjustment = 0,
        tax = 0,
        amount_paid = 0,
        balance = 0
      } = transaction.invoice || transaction;

      return {
        totalAmount: acc.totalAmount + total_amount,
        totalDiscount: acc.totalDiscount + discount,
        totalAdjustment: acc.totalAdjustment + adjustment,
        totalTax: acc.totalTax + tax,
        totalAmountPaid: acc.totalAmountPaid + amount_paid,
        totalBalance: acc.totalBalance + balance,
        calculatedTotal: acc.calculatedTotal + total_amount - discount - adjustment + tax
      };
    },
    {
      totalAmount: 0,
      totalDiscount: 0,
      totalAdjustment: 0,
      totalTax: 0,
      totalAmountPaid: 0,
      totalBalance: 0,
      calculatedTotal: 0
    }
  );
};
